module.exports = __webpack_public_path__ + "static/media/nomad_about_us_logo_700x400.910f742c.png";